import * as React from 'react';
import { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import SellerInvoicablesListRow from './SellerInvoicablesListRow';
import { Translate } from '../../shared/LanguageService';
import PendingInvoiceListRow from './PendingInvoiceListRow';
import { getOrderCssClass } from '../../shared/Site';

interface ISellerInvoicablesListProps {
    items: any[];
    showInvoice: (invoiceReceiverCheckSum: any) => void;
    pendingInvoices: any[];
    tryInvoiceAgain: (invoiceId: number) => void;
    onSelectedItemsChange: (selectedItems: any[]) => void;
}

const SellerInvoicablesList = (props: ISellerInvoicablesListProps) => {
    const [allChecked, setAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>({});

    useEffect(() => {
        const initialCheckedItems = props.items.reduce((acc, item) => {
            acc[item.id] = false;
            return acc;
        }, {} as { [key: number]: boolean });
        setCheckedItems(initialCheckedItems);
    }, [props.items]);

    useEffect(() => {
        const selectedItems = props.items.filter((_, index) => checkedItems[index]);
        props.onSelectedItemsChange(selectedItems);
    }, [checkedItems]);
    
    const handleHeaderCheckboxChange = () => {
        const newCheckedStatus = !allChecked;
        setAllChecked(newCheckedStatus);
        const newCheckedItems = props.items.reduce((acc, item, index) => {
            acc[index] = newCheckedStatus;
            return acc;
        }, {} as { [key: number]: boolean });
        setCheckedItems(newCheckedItems);
    };

    const handleRowCheckboxChange = (index: number) => {
        const newCheckedItems = { ...checkedItems, [index]: !checkedItems[index] };
        setCheckedItems(newCheckedItems);

        setAllChecked(Object.values(newCheckedItems).every((checked) => checked));
    };

    return (
        <Table hover responsive>
            <thead>
                <tr className={getOrderCssClass(3)}>
                    <th>
                        <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleHeaderCheckboxChange}
                        />
                    </th>
                    <th>{Translate('invoice/sellers/header/broker-firm-name')}</th>
                    <th>{Translate('invoice/sellers/header/order-count')}</th>
                    <th>{Translate('invoice/sellers/header/billing-method')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.pendingInvoices.map((pendingInvoice: any, index: number) => (
                    <PendingInvoiceListRow
                        tryagain={props.tryInvoiceAgain}
                        invoiceId={pendingInvoice.id}
                        key={index}
                        brokerFirmName={pendingInvoice.brokerFirmName}
                        invoiceBillingMethod={pendingInvoice.invoiceBillingMethod}
                        orderCount={0}
                        status={pendingInvoice.creationStatus}
                        site={pendingInvoice.site}
                    />
                ))}
                {props.items.map((invoice: any, index: number) => (
                    <SellerInvoicablesListRow
                        key={index}
                        brokerFirmName={invoice.brokerFirmName}
                        orderCount={invoice.orderCount}
                        invoiceBillingMethod={invoice.invoiceBillingMethod}
                        showInvoice={() => props.showInvoice(invoice.invoiceReceiverCheckSum)}
                        site={invoice.site}
                        checked={checkedItems[index] || false}
                        onCheckboxChange={() => handleRowCheckboxChange(index)}                        
                    />
                ))}
            </tbody>
        </Table>
    );
};

export default SellerInvoicablesList;
